export default __webpack_public_path__ + "resources/icons/n432-a3b6.png";